import { render, staticRenderFns } from "./RecoverView.vue?vue&type=template&id=a43b782e&scoped=true"
import script from "./RecoverView.vue?vue&type=script&lang=js"
export * from "./RecoverView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43b782e",
  null
  
)

export default component.exports